import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { REHYDRATE } from "redux-persist";

interface ApiDashboardState {
  dashboardData: any[]; // You can define a more specific type here
  apiStatus: "idle" | "loading" | "succeeded" | "failed";
  apiError: string | null;
}

const initialState: ApiDashboardState = {
  dashboardData: [],
  apiStatus: "idle",
  apiError: null,
};

export const fetchDashboardInfoForUserId = createAsyncThunk(
  "api/fetchApiData",
  async (endpoint: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(endpoint, {
      headers: { Authorization: "Bearer " + token },
    });
    console.log("Tab:", response);
    const tabs: any = {};
    if (response.data.obj.tab.length > 0) {
      tabs["values"] = response.data;
      tabs["value"] = response.data.obj.tab[0];
      tabs["widgetData"] = response.data.obj.tab[0].tabWidget;
    }
    return tabs;
  }
);

export const fetchDashboardInfoForUserIdTabId = createAsyncThunk(
  "api/fetchApiData",
  async ({ endpoint, tabId }: { endpoint: string; tabId?: number }) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(endpoint, {
      headers: { Authorization: "Bearer " + token },
    });
    console.log("Tab:", response);
    const tabseq = response.data.obj.tab;
    const position = tabseq.findIndex((tab: any) => tab.id === tabId);
    const tabs: any = {};
    if (response.data.obj.tab.length > 0) {
      tabs["values"] = response.data;
      tabs["value"] = response.data.obj.tab[position];
      tabs["widgetData"] = response.data.obj.tab[position].tabWidget;
    }
    return tabs;
  }
);

export const fetchDashboardInfoForUserIdAlter = createAsyncThunk(
  "api/fetchApiData",
  async (endpoint: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(endpoint, {
      headers: { Authorization: "Bearer " + token },
    });
    const tabs: any = {};
    if (response.data.obj.tab.length > 0) {
      tabs["values"] = response.data;
      tabs["value"] = response.data.obj.tab[response.data.obj.tab.length - 1];
      tabs["widgetData"] =
        response.data.obj.tab[response.data.obj.tab.length - 1].tabWidget;
    }
    return tabs;
  }
);
const dashboardInfo = createSlice({
  name: "apiDashboardUserId",
  initialState,
  reducers: { resetDashboardUserState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardInfoForUserId.pending, (state) => {
        state.apiStatus = "loading";
      })
      .addCase(
        fetchDashboardInfoForUserId.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.apiStatus = "succeeded";
          state.dashboardData = action.payload;
        }
      )
      .addCase(fetchDashboardInfoForUserId.rejected, (state, action) => {
        state.apiStatus = "failed";
        state.apiError = action.error.message || "Failed to fetch data";
      })
      .addCase(REHYDRATE, (state, action: any) => {
        // state.apiStatus = "succeeded";
        // state.dashboardData =
        // action.payload.apiDashboardForUserId.dashboardData;
      });
  },
});

export const { resetDashboardUserState } = dashboardInfo.actions;

export default dashboardInfo.reducer;
